export const ElevatorOff = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#868C98"
      strokeMiterlimit="10"
      d="M8.502 7.634h.996m-2.998 0h1.001m2.998 0h1M9 9.274V18m-6 0h12M3.996 6h10.003v12H3.996zm2.001 3.274h6V18h-6z"
    />
    <path
      stroke="#868C98"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19.25 11.75-1.5 1.5m0-1.5 1.5 1.5M21 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    />
  </svg>
);
